/* eslint-disable @typescript-eslint/no-empty-function */
import CopyRight from "src/components/atoms/copy-right/CopyRight";
import Footer from "src/components/molecules/footer/footer";
import BusinessList from "src/components/organisms/businessList/business-list";
import MenuBar from "src/components/organisms/menuBar/menuBar";

const Dashboard: React.FC = () => {
  return (
    <>
      <div className="bg-gradient-to-b from-neutral-800 to-neutral-900 h-screen">
        <MenuBar></MenuBar>
        <BusinessList></BusinessList>
        <Footer>
          <CopyRight></CopyRight>
        </Footer>
      </div>
    </>
  );
};

export default Dashboard;
